import { Box, Button, Stack, TableCell, TableRow, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import '../../../../css/partyBooking.scss'
import { headerTblDefs, partyAsList, groupDataDetailed, excelHeader, groupDataDetailedSummary, summaryTblColDefs } from './const'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { buildCompositeFields, focusElemnt, getInt, navigation3 } from '../../../common/helper'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait } from '../../../common/helper'
import { callAddFontRobotoBold } from '../../../common/font/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/font/Roboto-Medium-normal'
import AppsIcon from '@mui/icons-material/Apps'
import * as mdt from '../../../common/modaltypes'
import { useAtom } from 'jotai'
import { modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import useToken from '../../../helpers/useTokens'
import { CargoRoleRightsAtom } from '../../../common/jotaiState/commonStateAtoms'
import VirtualizedTable from '../../../common/virtualisedTable'
import { jsPdfHeaderFooter } from '../GoodBalance/constants'
import { makeTable } from '../analysisReport/pdfAutotable'
import { divideInNIntegers } from '../../../common/mathHelper'
import { exportToExcel } from '../../../common/hook'

const reportname = 'Party Booking Report'
const DetailedPartyBookingTable = (props) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const { loginData } = useToken()
  const [, setModal] = useAtom(modalAtom)

  const { dataValues, columnDefs } = props
  const {
    partyCityName,
    partyName,
    partyAsId,
    reportView,
    fromDate,
    toDate,
    paymentModeName,
    detailedTableData,
    companyName,
    receiverTableData,
    senderTableData,
  } = dataValues
  const [data, setData] = useState([])
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  const { AllowExportExcel } = { ...roleRightsData }
  const [isPdfLoaded, setIsPdfLoaded] = useState(false)
  const [smryRptHeading, setSmryRptHeading] = useState('')
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')

  const headers = (reportView?.id === 0 ? columnDefs : summaryTblColDefs).map((a) => ({
    ...a,
    field: a.dataKey,
    align: a.xlCol.dataType === 'quantity' ? 'right' : 'left',
    width: getInt(a.minWidth),
  }))
  const span1 = divideInNIntegers(headers.length, 2)
  const lengths = divideInNIntegers(headers.length, 8)
  const header1 = [
    [
      { header: `Report For: ${smryRptHeading}`, field: '', span: span1[0], mainHeader: true },
      { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
    ],
  ]
  excelHeader.map((item, index) => {
    item.colSpan = lengths[index] || 1
  })
  const headerData = [
    {
      reportView: reportView.name,
      partyAsName: partyAsList[partyAsId].name,
      fromDate,
      toDate,
      companyName,
      paymentModeName,
      partyCityName,
      partyName,
    },
  ]
  const excelHeaderList = [header1, excelHeader]
  const excelDataList = [[], headerData]
  const excelHeaders = headers.flatMap((col) => {
    if (typeof col.field === 'string' && col.field.includes('^^')) {
      const [field1, field2] = col.field.split('^^')
      const [header1, header2] = (col.exportHead || '').split('\n')
      return [
        { field: field1, header: header1, textAlign: col.align },
        { field: field2, header: header2, textAlign: col.align },
      ]
    }
    return { field: col.field, header: col.exportHead || col.header, textAlign: col.align }
  })
  excelHeaderList.push(excelHeaders)
  const excelTableData = data.map((row) => {
    if (row.dataType === 'total') {
      return {
        ...row,
        colSpan: { [excelHeaders[0].field]: excelHeaders.findIndex((item) => item.field === 'STATUS') + 1 },
        align: { [excelHeaders[0].field]: 'right' },
      }
    }
    return row
  })
  excelDataList.push(excelTableData)

  useEffect(() => {
    if (reportView.id === 0) {
      if (detailedTableData.length) {
        const newList = detailedTableData.map((item) => ({ ...item, ...buildCompositeFields(item, headers) }))
        const list = groupDataDetailed(newList, headers, loginData?.intCompanyID)
        setData(list)
      }
    } else {
      const list = groupDataDetailedSummary(senderTableData, receiverTableData, partyAsId, headers)
      setData(list)
    }
  }, [detailedTableData])

  useEffect(() => {
    if (reportView.id === 0) {
      if (partyAsId === 0) {
        setSmryRptHeading('Both Sender & Receiver Party Details')
      } else if (partyAsId === 1) {
        setSmryRptHeading('Sender Party Details')
      } else if (partyAsId === 2) {
        setSmryRptHeading('Receiver Party Details')
      } else if (partyAsId === 3) {
        setSmryRptHeading('Payment Responsibility Party Details')
      }
    } else {
      if (partyAsId === 0) {
        setSmryRptHeading('Sender Party Summary')
      } else if (partyAsId === 1) {
        setSmryRptHeading('Sender Party Summary')
      } else if (partyAsId === 2) {
        setSmryRptHeading('Receiver Party Summary')
      } else if (partyAsId === 3) {
        setSmryRptHeading('Payment Responsibility Party Summary')
      }
    }
  }, [partyAsId])

  const summaryTblHeaderBody = [
    {
      companyName: companyName,
      paymentModeName: paymentModeName,
      partyCityName: partyCityName,
      partyName: partyName,
      partyAsName: partyAsList[partyAsId]?.name,
      dataType: 'entry',
    },
  ]

  const generatePdf = (isSave) => {
    try {
      setIsPdfLoaded(false)
      const widthCell = headers.reduce((acc, curr) => {
        return acc + getInt(curr.minWidth)
      }, 0)

      jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
      jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
      const dimension =
        headers.length > 18
          ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60)
          : calculateDynamicFormatPortrait((widthCell > 900 ? widthCell : 900) + 60)
      const doc = new jsPDF({
        orientation: headers.length > 18 ? 'l' : 'p',
        format: dimension,
        unit: 'px',
        compress: true,
      })

      var pdfFontSize = reportView.id === 0 ? 1.4 : 1.2

      doc.setProperties({
        title: `PartyBookingReport.pdf`,
        subject: 'Party Booking',
        author: 'Maven Tech Labs Pvt. Ltd.',
        keywords: 'maven tech, Cargo system, Party Booking Report',
        creator: 'MTLPL',
      })

      var totalPagesExp = '{total_pages_count_string}'
      const customFunction = (data, doc) => {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(pdfFontSize * 16)
        doc.setFont('Roboto', 'normal')
        doc.text(`Booking Date: ${fromDate} To ${toDate}`, 30, 170)
        doc.setFontSize(pdfFontSize * 16)
        doc.setFont('Roboto', 'bold')
        doc.text(
          `Report View: ${reportView.id === 0 ? 'Detailed' : 'Summary'}`,
          doc.internal.pageSize.width - data.settings.margin.left,
          170,
          'right'
        )
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      }
      const customFunction2 = (data, doc) => {
        doc.setTextColor(pdfFontSize * 40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(pdfFontSize * 20).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Party Booking Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(pdfFontSize * 20).setFont('Roboto', 'normal')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
      }
      makeTable(doc, autoTable, headerTblDefs, summaryTblHeaderBody, pdfFontSize, '', loginData, 'everyPage', customFunction, 190, false)

      makeTable(doc, autoTable, headers, data, pdfFontSize, '', loginData, 'everyPage', customFunction2, 120, true)
      doc.setFont('Roboto')
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      setIsPdfLoaded(true)
      setTimeout(() => {
        const pdfUrl = doc.output('bloburl')
        document.getElementById('prtyBkngOutput').data = pdfUrl
        // document.getElementById('prtyBkngOutput').data = doc.output('datauristring', 'PartyBookingReport.pdf')
        focusElemnt('dtledBackBtn')
      }, 1000)
      if (isSave) {
        doc.save(`Party Booking Detailed Report ${currentDateTime}.pdf`)
      }
    } catch (err) {
      console.log(err)
      setIsPdfLoaded(false)
    }
  }
  const headerContent = () => {
    return (
      <>
        <TableRow className="sammary-heading" style={{ position: 'sticky', top: '0px' }}>
          <TableCell
            colSpan={headers.length - Math.floor(headers.length / 4) * 3}
            style={{
              fontSize: '12px',
              fontFamily: 'Roboto',
              fontWeight: '900',
              paddingLeft: '10px',
              textAlign: 'left',
              backgroundColor: '#BFE1FF',
              color: '#444444',
              borderTop: '1px solid #ddd',
              borderTopLeftRadius: '3px',
            }}
          >
            Party Booking Report: {smryRptHeading}
          </TableCell>
          <TableCell
            colSpan={Math.floor(headers.length / 4)}
            style={{
              fontSize: '12px',
              fontFamily: 'Roboto',
              fontWeight: '900',
              paddingLeft: '10px',
              textAlign: 'center',
              backgroundColor: '#BFE1FF',
              color: '#444444',
              borderTop: '1px solid #ddd',
            }}
          >
            Selected City: {partyCityName}
          </TableCell>
          <TableCell
            colSpan={Math.floor(headers.length / 4)}
            style={{
              fontSize: '12px',
              fontFamily: 'Roboto',
              fontWeight: '900',
              paddingLeft: '10px',
              textAlign: 'center',
              backgroundColor: '#BFE1FF',
              color: '#444444',
              borderTop: '1px solid #ddd',
            }}
          >
            Selected Party: {partyName}
          </TableCell>
          <TableCell
            colSpan={Math.floor(headers.length / 4)}
            style={{
              fontSize: '12px',
              fontFamily: 'Roboto',
              fontWeight: '900',
              paddingLeft: '10px',
              textAlign: 'right',
              backgroundColor: '#BFE1FF',
              color: '#444444',
              borderTop: '1px solid #ddd',
            }}
          >
            Show Party As: {partyAsList[partyAsId].name}
          </TableCell>
        </TableRow>
        <TableRow>
          {headers.map((item) => {
            return (
              <TableCell
                style={{
                  backgroundColor: '#e5f3ff',
                  color: '#444',
                  fontSize: '12px',
                  lineHeight: '16px',
                  letterSpacing: '0.24px',
                  fontWeight: '600',
                  whiteSpace: 'pre-line',
                  padding: '6px 8px',
                  width: item.width,
                  textAlign: item.align || 'left',
                  minWidth: item.minWidth || 'auto',
                }}
                colSpan={1}
              >
                {item?.header}
              </TableCell>
            )
          })}
        </TableRow>
      </>
    )
  }
  const bodyContent = (index, obj) => {
    const fieldMap = {
      PayType: 'PayType_view',
      STATUS: 'STATUS_view',
      BookingGSTInvoiceNo: 'BookingGSTInvoiceNo_view',
      DeliveryGSTInvoiceNo: 'DeliveryGSTInvoiceNo_view',
    }
    return (
      <DisPatchBody
        row={obj}
        index={index}
        tableHeaderColor={tableHeaderColor}
        columnDefs={headers.map((item) => ({ ...item, field: fieldMap[item.field] || item.field }))}
      />
    )
  }
  return (
    <Box style={{ padding: '0px 14px 0px 14px' }}>
      <Stack style={{ padding: '0px 0px' }}>
        <Item className="partyBookingReport" style={{ padding: '4px 0px 12px 0px', marginBottom: '-6px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Item className="userReport-heading" style={{ color: '#444444', marginBottom: '0px' }}>
              Party Bookings Report: Detailed
            </Item>
            <Box
              sx={{
                minHeight: '32px',
                display: 'flex',
                padding: '8px 12px',
                justifycontent: 'center',
                alignitems: 'center',
                gap: '6px',
                marginX: '10px',
                fontSize: '14px',
              }}
              id="dispatchReportManageColumn"
              tabIndex={0}
              onClick={() => setModal(mdt.DetailedPartyBookingmodal)}
            >
              <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                <AppsIcon />
              </span>
              <span tabIndex={0} style={{ fontWeight: '600' }}>
                MANAGE COLUMNS
              </span>
            </Box>
          </Box>
          <Item className="userReport-buttons" style={{ padding: '0px 0px 5px 0px' }}>
            {!isPdfLoaded ? (
              <>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    disabled={!AllowExportExcel}
                    onClick={() =>
                      exportToExcel({
                        fileName: `${reportname} ${currentDateTime}.xlsx`,
                        sheetName: reportname,
                        headersList: excelHeaderList,
                        dataList: excelDataList,
                      })
                    }
                  >
                    Export to Excel
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    id="exportAsPdfBtn"
                    onKeyDown={(e) => {
                      navigation3(e, 'printBtn', AllowExportExcel ? 'test-table-xls-button' : 'prtyBkngSplitBtn', () => {
                        setIsPdfLoaded(false)
                        generatePdf(true)
                      })
                    }}
                    onClick={() => {
                      setIsPdfLoaded(false)
                      generatePdf(true)
                    }}
                  >
                    Export As Pdf
                  </Button>
                </Box>
                <Box>
                  <Button
                    id="printBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onKeyDown={(e) => {
                      navigation3(e, 'prtyBkngFromDate', 'exportAsPdfBtn', () => {
                        setIsPdfLoaded(false)
                        generatePdf(false)
                      })
                    }}
                    onClick={() => {
                      setIsPdfLoaded(false)
                      generatePdf(false)
                    }}
                  >
                    Print
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Button
                    id="dtledBackBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    style={{ marginBottom: '10px' }}
                    onClick={() => {
                      setIsPdfLoaded(false)
                    }}
                    onKeyDown={(e) => {
                      navigation3(e, 'prtyBkngFromDate', 'dtledBackBtn', () => {
                        setIsPdfLoaded(false)
                        focusElemnt('prtyBkngFromDate')
                      })
                    }}
                  >
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      {!isPdfLoaded ? (
        <Stack className="party-booking-detail-tbl">
          <VirtualizedTable
            tableData={data}
            headerContent={headerContent}
            rowContent={bodyContent}
            tableStyle={{ tableLayout: 'auto', width: '100%' }}
            autoResize={true}
          />
        </Stack>
      ) : (
        <object
          id="prtyBkngOutput"
          type="application/pdf"
          width={window.innerWidth - 40}
          height="440"
          title="MTLPL - Party Booking Report"
          aria-label="MTLPL - CARGO - Party Booking Report"
        ></object>
      )}
    </Box>
  )
}
const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs }) => {
  if (!row?.dataType) return null
  const getStyles = (field, align) => {
    const common = {
      minHeight: '36px',
      fontSize: '12px',
      color: '#444',
      padding: '6px 8px',
      whiteSpace: 'pre',
    }
    if (row.dataType === 'entry') {
      return {
        ...common,
        fontWeight: '500',
        textAlign: align || 'left',
        height: '36px',
      }
    }
    if (row.dataType === 'subHeader') {
      return {
        ...common,
        fontWeight: '600',
        backgroundColor: tableHeaderColor?.isSubHeadingColor,
        textAlign: row.align?.[field] || 'left',
        position: 'sticky',
        top: '94px',
      }
    }
    if (row.dataType === 'total') {
      return {
        ...common,
        fontWeight: '600',
        backgroundColor: tableHeaderColor?.isTotalColor,
        textAlign: row.align?.[field] || 'right',
      }
    }
  }

  return (
    <>
      {(() => {
        let skip = 0

        return columnDefs.map((item, i) => {
          if (skip > 0) {
            skip--
            return null
          }
          const colSpan = row.colSpan?.[item.field] || 1
          skip = colSpan - 1
          return (
            <TableCell className="reportTD" key={item.field + i + index} colSpan={colSpan} style={getStyles(item.field, item.align)}>
              {row[item.field]}
            </TableCell>
          )
        })
      })()}
    </>
  )
}
export default DetailedPartyBookingTable
